"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/RichMessageWrapper/DeliveryStatus.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _hooks = require('web/services/hooks');





var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _message = require('shared/enum/message');





var _smsDelivery = require('shared/services/smsDelivery');
var _peers = require('shared/selectors/peers');
var _Avatar = require('web/components/Avatar');
var _Tooltip = require('web/components/Tooltip');
var _keyboard = require('web/services/keyboard');






















// "SMS rejected" / "SMS partially rejected" / "Blocked by carrier" /
// "Blocked by admin": the text for this message was refused, usually for
// recipients on the org's undeliverable list (opted out, carrier-blocked,
// admin-blocked), sometimes for a consent hold that ended unsent.
// Distinct from the local send failure above: the message itself was
// delivered to the conversation, and the badge has no Retry. For an opt-out,
// carrier block, admin block or unreachable number, sending again fails until
// the patient opts back in (or texts START to the number their carrier
// blocks), an admin unblocks the number, or the number changes. A text that
// waited for consent and wasn't sent ('consent_not_sent') can be sent again.
 const SMSRejectedBadge = ({ outcomes }) => {
  const summary = _smsDelivery.summarizeSMSOutcomes.call(void 0, outcomes)
  const patientsV1 = _hooks.useAppSelector.call(void 0, _peers.selectAllV1Patients)
  const patientsV2 = _hooks.useAppSelector.call(void 0, _peers.selectAllV2Patients)
  if (!summary) return null

  const patients = { ...patientsV1, ...patientsV2 }
  const names = _smsDelivery.describeSMSRejectedRecipients.call(void 0, summary, k => _optionalChain([patients, 'access', _ => _[k], 'optionalAccess', _2 => _2.Name]) || 'A patient')
  const tooltip = (
    _react2.default.createElement(_Tooltip.TooltipContent, { className: "delivery-status-tooltip--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
      , _react2.default.createElement('span', { className: "delivery-status-tooltip--hint-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
        ,  _smsDelivery.smsRejectionTooltipTitle.call(void 0, summary) 
      )
      ,  names.map((name, i) => (
        _react2.default.createElement('span', { key: `${name}-${i}`, className: "delivery-status-tooltip--hint-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
          ,  name 
        )
      ))
    )
  )

  return (
    _react2.default.createElement(_Tooltip.HoverTooltip, {
      place: "top",
      type: "dark",
      content: tooltip,
      className: "delivery-status-tooltip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}

      , _react2.default.createElement('div', {
        className: _classBuilder2.default.call(void 0, 
          "rich-message--delivery-status--sms-rejected",
          summary.label === _smsDelivery.SMS_CARRIER_BLOCKED_LABEL && "rich-message--delivery-status--sms-rejected--carrier",
        ),
        role: "status",
        'aria-label': `${summary.label}: ${names.join(', ')}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}

        , _react2.default.createElement('img', { src: "/assets/icons/alert-orange.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}} )
        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 89}},  summary.label )
      )
    )
  )
}; exports.SMSRejectedBadge = SMSRejectedBadge

const DeliveryStatus = ({
  status = _message.deliveryStatus.DELIVERED,
  shouldShowDeliveredIndicator,
  seenBySubscribers,
  onRetry,
  isLastMessage,
  uploadLabel,
  failureLabel = 'Could not be sent',
  canRetry = true,
  supportUrl,
  smsDeliveryOutcomes,
}) => {
  const isSent = status === _message.deliveryStatus.SENT
  const isDelivered = status === _message.deliveryStatus.DELIVERED
  const hasFailed = status === _message.deliveryStatus.FAILED

  const hasBeenSeen = isDelivered && !!seenBySubscribers.length
  const hasSMSRejection = !!_smsDelivery.summarizeSMSOutcomes.call(void 0, smsDeliveryOutcomes)

  // A failure always shows, so every failed part of a send keeps its Retry.
  if (!hasBeenSeen && !shouldShowDeliveredIndicator && !hasFailed && !hasSMSRejection && !(isSent && uploadLabel)) {
    return isLastMessage
      ? _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 
        "rich-message--delivery-status",
        "rich-message--delivery-status--last",
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}} )
      : null
  }

  // The visible label says "Seen by"; the hover lists who.
  const seenByTooltipContent = (
    _react2.default.createElement(_Tooltip.TooltipContent, { className: "delivery-status-tooltip--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
      ,  seenBySubscribers.map(s => (
        _react2.default.createElement('span', {
          key: s.SubscriberKey,
          className: "delivery-status-tooltip--hint-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}

          ,  s.Name 
        )
      ))
    )
  )

  const sentByTooltipContent = (
    _react2.default.createElement(_Tooltip.TooltipContent, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}
      , _react2.default.createElement('span', { className: "delivery-status-tooltip--hint-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}}, "Sent by "
          , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}, "You")
      )
    )
  )

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 
      "rich-message--delivery-status",
      isLastMessage && "rich-message--delivery-status--last",
    ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 147}}
      ,  isSent && _react2.default.createElement('div', { className: "rich-message--delivery-status--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}} ) 
      ,  isSent && uploadLabel && (
        // Not a live region: it changes every percent.
        _react2.default.createElement('span', { className: "rich-message--delivery-status--upload", __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}}, uploadLabel)
      )
      ,  shouldShowDeliveredIndicator &&
        isDelivered &&
        !hasBeenSeen && (
          _react2.default.createElement(_Tooltip.HoverTooltip, {
            place: "top",
            type: "dark",
            content: sentByTooltipContent,
            className: "delivery-status-tooltip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}

            , _react2.default.createElement('div', { className: "rich-message--delivery-status--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 165}}
              , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 166}}, "check"), "Sent"

            )
          )
      )
      ,  hasFailed && (
        _react2.default.createElement('div', { className: "rich-message--delivery-status--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}}
          , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}, "error_outline")
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 174}}, failureLabel, canRetry && _react2.default.createElement(_react2.default.Fragment, null, " ·" ))
          , canRetry && _react2.default.createElement('a', { role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown, onClick: onRetry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 175}}, "Retry")
          , supportUrl && _react2.default.createElement('a', { href: supportUrl, target: "_blank", rel: "noreferrer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}, "Contact BloomText support"  )
        )
      )
      ,  hasSMSRejection && smsDeliveryOutcomes && (
        _react2.default.createElement(exports.SMSRejectedBadge, { outcomes: smsDeliveryOutcomes, __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}} )
      )
      ,  hasBeenSeen && (
        _react2.default.createElement(_Tooltip.HoverTooltip, {
          place: "top",
          type: "dark",
          content: seenByTooltipContent,
          className: "delivery-status-tooltip delivery-status-tooltip--seen-by" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}

          , _react2.default.createElement('div', { className: "rich-message--delivery-status--seen-by", __self: this, __source: {fileName: _jsxFileName, lineNumber: 189}}
            , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}}, "check")
            , _react2.default.createElement('span', { className: "rich-message--delivery-status--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 191}}, "Seen by" )
            ,  seenBySubscribers.map(s => (
              _react2.default.createElement(_Avatar.UserAvatar, {
                noOnlineIndicator: true,
                key: s.SubscriberKey,
                userKey: s.SubscriberKey ,
                borderColor: "var(--bg-app)",
                size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 193}}
              )
            ))
          )
        )
      )
    )
  )
}

// Memoized: the row re-renders on hover and menu state, which never changes
// the delivery status inputs.
exports. default = _react2.default.memo(DeliveryStatus)
